<template>
  <v-text-field
    type="number"
    :disabled="disabled"
    :readonly="field.isReadOnly"
    v-bind:label="labelText"
    v-model="fieldValue"
    v-bind:min="field.validations.minVal"
    v-bind:max="field.validations.maxVal"
    :hint="field.observations"
    :error-messages="fieldErrors"
    @change="onChange"
    @input="validator.document.fields.$each[index].value.$touch();"
    @blur="validator.document.fields.$each[index].value.$touch()"
  ></v-text-field>
</template>
<script>
import { EventBus } from "@/eventBus.js";

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
    ctIndex: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fieldChangeSource: {
      type: Number,
      default: 0
    }
  },
  computed: {
    labelText() {
      return `${this.field.title}${this.field.isRequired ? " *" : ""}`;
    },
    fieldValue: {
      // getter
      get: function () {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        var userThouSep = this.$store.getters["account/user"].MetricThousandSep;
        return this.field.value
          .replaceAll(userThouSep, "")
          .replaceAll(userDecSep, ".");
      },
      // setter
      set: function (newValue) {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        this.field.value = newValue.replaceAll(".", userDecSep);
      },
    },
    fieldErrors() {
      const errors = [];

      if (this.validator.document) {
        const field = this.validator.document.fields.$each[this.index];

        if (!field.value.$dirty) {
          return errors;
        }

        if (!field.value.required && !field.$model.value) {
          errors.push(this.$t("RequiredField"));
        }

        if (!field.value.minValue || !field.value.maxValue) {
          errors.push(this.$t("NumericFieldValidationError"));
        }

      } else if (this.validator.contentTypeList) {
        const field = this.validator.contentTypeList.$each[this.ctIndex].document.fields.$each[this.index];

        if (!field.value.$dirty) {
          return errors;
        }

        if (!field.value.required && !field.$model.value) {
          errors.push(this.$t("RequiredField"));
        }
      }
      return errors;
    },
  },
  methods: {
    onChange() {
      EventBus.$emit('field-edited', this.field, this.fieldChangeSource);
    },
  },
};
</script>
